var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399901 7.98662L3.64484 4.525L0.399902 1.06337L1.39889 1.72587e-07L5.6499 4.525L1.39889 9.05L0.399901 7.98662Z",
    fill: "#0F0B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowRight);
export default __webpack_public_path__ + "static/media/black-arrow-right.978632e63515fcf7eccc55087728651f.svg";
export { ForwardRef as ReactComponent };